const urlApiDev = process.env.SDAGENDA_API_DEV
const urlApiProd = process.env.SDAGENDA_API_PROD

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'homologacao.certificadorapadrao.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd

const headers = {
  'x-access-token': 'mongodb-direct',
  'content-type': 'application/json',
}

export const state = () => ({
  slots: [],
  sdagenda: {},
})

export const getters = {
  sdagenda: (state) => state.sdagenda,
}

export const mutations = {
  SET_SLOTS: (state, payload) => (state.slots = payload),
  SET_COOKIE_SDAGENDA: (state, payload) => (state.sdagenda = payload),
}

export const actions = {
  async scheduling({ commit }, dataScheduling) {
    const unidade = this.getters['unidade/unidadeInformation']
    const data = await this.$axios.$post(
      `https://${unidade.agenda.ambiente}.sdagenda.com.br/api/agendamento`,
      dataScheduling,
      { headers }
    )
    return data
  },
  async schedulingStatus({ commit }, pedido) {
    const unidade = this.getters['unidade/unidadeInformation']
    const data = await this.$axios.$get(
      `https://${unidade.agenda.ambiente}.sdagenda.com.br/api/status-agendamento/${pedido}`,
      { headers }
    )
    return data
  },

  verifysdagenda({ commit }) {
    const unidade = this.getters['unidade/unidadeInformation']
    const data = unidade.agenda
    commit('SET_COOKIE_SDAGENDA', data)
  },

  async captureTicket({ commit }, ticketOwner) {
    const data = await this.$axios.$post(
      `${urlApi}/ticket/capture-site`,
      ticketOwner,
      { headers }
    )
    return data
  },

  async fetchCnpj({ commit }, cnpj) {
    const data = await this.$axios.$get(`${urlApi}/consulta-externa/${cnpj}`, {
      headers,
    })
    return data
  },
}
